import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { HerausgebersQuerySorterConfig } from 'fa-kt.types';
import { HerausgebersService } from '../service';

@Component({
  selector: 'fa-kt-herausgebers-sorter',
  templateUrl: './herausgebers-sorter.component.html',
  styleUrls: ['./herausgebers-sorter.component.css'],
})
export class HerausgebersSorterComponent {
  HerausgebersSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public herausgebers: HerausgebersService,
  ) {
    this.HerausgebersSorterConfig = HerausgebersQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
